import React from 'react';
import { useDemoMode } from '../contexts/DemoModeContext';

export const HistoryModal = ({ isOpen, onClose }) => {
  const { demoPortfolio } = useDemoMode();

  if (!isOpen) return null;

  console.log('📚 HISTORY MODAL DEBUG:', {
    'Raw demoPortfolio': demoPortfolio,
    'All trades': demoPortfolio.trades || [],
    'Trades length': (demoPortfolio.trades || []).length,
    'First trade': (demoPortfolio.trades || [])[0]
  });

  const closedTrades = (demoPortfolio.trades || []).filter(trade => trade.status === 'closed');
  
  console.log('📚 CLOSED TRADES DEBUG:', {
    'All trades': demoPortfolio.trades || [],
    'Closed trades': closedTrades,
    'Closed trades length': closedTrades.length,
    'Trade statuses': (demoPortfolio.trades || []).map(trade => ({ id: trade.id, status: trade.status, side: trade.side }))
  });

  const formatDuration = (entryTime, exitTime) => {
    const start = new Date(entryTime);
    const end = new Date(exitTime);
    const diff = end - start;
    
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    
    if (days > 0) return `${days}d ${hours}h`;
    if (hours > 0) return `${hours}h ${minutes}m`;
    return `${minutes}m`;
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-atticus-navy-900 rounded-xl max-w-4xl w-full max-h-[80vh] overflow-y-auto">
        <div className="p-6 border-b border-gray-600">
          <div className="flex justify-between items-center">
            <h2 className="text-2xl font-bold text-white">Trade History</h2>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-white text-2xl"
            >
              ×
            </button>
          </div>
        </div>

        <div className="p-6">
          {closedTrades.length === 0 ? (
            <div className="text-center text-gray-400 py-8">
              <div className="text-lg font-medium">No Trade History</div>
              <div className="text-sm">Closed positions will appear here</div>
            </div>
          ) : (
            <div className="space-y-4">
              {closedTrades.map((trade) => (
                <div key={trade.id} className="bg-atticus-navy-800 rounded-lg p-4">
                  <div className="flex justify-between items-start mb-3">
                    <div>
                      <div className="text-white font-bold text-lg">
                        {trade.side.toUpperCase()} {trade.quantity} {trade.type.toUpperCase()}
                      </div>
                      <div className="text-gray-400">Strike: ${trade.strike.toLocaleString()}</div>
                    </div>
                    <div className="text-right">
                      <div className={`font-bold text-lg ${trade.finalPnL >= 0 ? 'text-green-400' : 'text-red-400'}`}>
                        {trade.finalPnL >= 0 ? '+' : ''}${trade.finalPnL?.toLocaleString()}
                      </div>
                      <div className="text-gray-400 text-sm">Final P&L</div>
                    </div>
                  </div>
                  
                  <div className="grid grid-cols-3 gap-4 text-sm">
                    <div>
                      <span className="text-gray-400">Entry:</span>
                      <span className="text-white ml-2">${trade.entryPrice?.toLocaleString()}</span>
                    </div>
                    <div>
                      <span className="text-gray-400">Exit:</span>
                      <span className="text-white ml-2">${trade.exitPrice?.toLocaleString()}</span>
                    </div>
                    <div>
                      <span className="text-gray-400">Duration:</span>
                      <span className="text-white ml-2">
                        {formatDuration(trade.timestamp, trade.exitTime)}
                      </span>
                    </div>
                  </div>
                  
                  <div className="mt-2 text-xs text-gray-500">
                    Closed: {new Date(trade.exitTime).toLocaleDateString()} {new Date(trade.exitTime).toLocaleTimeString()}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
